import { useCallback } from 'react';
import { useAuthStore } from '../stores/useAuthStore';
import {
  getCommunityRole as getCommunityRoleUtil,
  isCheckInUser,
  isEditorUser,
  isOwnerUser,
} from '../utils/auth';

/**
 * Hook for checking user permissions for communities
 */
export function useUserPermissions() {
  const { ownedCommunityIds, editorCommunityIds, checkInCommunityIds } =
    useAuthStore();

  const isOwner = useCallback(
    (selectedCommunityId?: string) =>
      isOwnerUser(ownedCommunityIds, selectedCommunityId),
    [ownedCommunityIds],
  );

  const isEditor = useCallback(
    (selectedCommunityId?: string) =>
      isEditorUser(ownedCommunityIds, editorCommunityIds, selectedCommunityId),
    [ownedCommunityIds, editorCommunityIds],
  );

  const isCheckIn = useCallback(
    (selectedCommunityId?: string) =>
      isCheckInUser(checkInCommunityIds, selectedCommunityId),
    [checkInCommunityIds],
  );

  const getCommunityRole = useCallback(
    (selectedCommunityId?: string) =>
      getCommunityRoleUtil(
        ownedCommunityIds,
        editorCommunityIds,
        checkInCommunityIds,
        selectedCommunityId,
      ),
    [ownedCommunityIds, editorCommunityIds, checkInCommunityIds],
  );

  return {
    isOwner,
    isEditor,
    isCheckIn,
    getCommunityRole,
  };
}
